import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-jury-management',
  templateUrl: './jury-management.component.html',
  styleUrls: ['./jury-management.component.sass']
})
export class JuryManagementComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    document.querySelector(".__page-root").scrollIntoView(true);
  }

}
